import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {environment} from "../../environments/environment";


@Injectable({
  providedIn: 'root'
})
export class PartnerdatamanagementService {
  constructor(private httpClient: HttpClient) { }
  getPartners(): Observable<any> {
    return this.httpClient.post(`${environment.ServicePartnerDataURL}/partnerdata/GetAllPartner`,{});
  }
  
}
